// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"411aaff3","787":"429cc058"}[chunkId] + ".chunk.js";
};